import { settings } from "./settings";

export const getLocalStorageItemName = () => {
  return "hmc-" + settings.brand + "-" + settings.locale;
};

export let ls = {
  set: (k, v) => {
    localStorage.setItem(k, v);
  },
  setObj: (k, v) => {
    localStorage.setItem(k, JSON.stringify(v));
  },
  get: (k) => {
    return JSON.parse(localStorage.getItem(k)) || false;
  },
  getRaw: (k) => {
    return localStorage.getItem(k) || false;
  },
  getKey: getLocalStorageItemName,
  getKeyLeadForm: () => {
    return getLocalStorageItemName() + "_leadform";
  },
};
